import { useRef, useEffect, useState } from "react";
import bgSrc from "../../assets/images/ic-fourthpage-bg.svg";
import iosIntroSrc from "../../assets/images/ios-g1cash-intro.png";
import iosSwapSrc from "../../assets/images/ios-g1cash-swap.png";
import iosStoreSrc from "../../assets/images/ios-g1cash-store.png";
import "./fourthpage.css";

const FourthPage = () => {
    const fourthPageRef = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        //for interaction
        const observer = new IntersectionObserver(
            (entries) => {
                entries.map((entry) => {
                    if (entry.isIntersecting && !entry.target.classList.contains("show")) {
                        setShow(true);
                    }
                });
            },
            { threshold: 0.5 }
        );
        observer.observe(fourthPageRef.current);
    }, []);

    return (
        <div className={`${show ? "show" : ""} fourth-page`} ref={fourthPageRef}>
            <img src={bgSrc} className="fourth-page-bg" />
            <div className="fourth-page-top">
                <div className="fourth-title title">
                    {"An innovative\n"}
                    <span>Consumption lifestyle!</span>
                </div>
                <div className="fourth-subtitle subtitle">
                    {"Unlock a new level of online and offline\n consumption lifestyle with "} <span>G1CASH.</span>{" "}
                </div>
            </div>

            <div className="fourth-page-bottom">
                <img className="fourth-page-swap" src={iosStoreSrc} />
                <img className="fourth-page-store" src={iosSwapSrc} />
                <img className="fourth-page-intro" src={iosIntroSrc} />
            </div>
        </div>
    );
};

export default FourthPage;
